module.exports = __webpack_public_path__ + "static/content1-img-dc4b69a31d3ecd963928e9d113549270.png";